import script from "./NotificationAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationAlert.vue?vue&type=script&setup=true&lang=js"

import "./NotificationAlert.vue?vue&type=style&index=0&id=d0f238d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f238d8"]])

export default __exports__